import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

export const calculateDays = (createTime: string) => {
  dayjs.extend(relativeTime);

  return dayjs(createTime).fromNow();
};
